<div class="sidebar-container" style="width: 100%; height: 100%">
  <!-- Hidden drawer element for the service to reference -->
  <div #sideNav data-tour="sidebar" class="sidebar-drawer" style="display: none;"></div>
  <!-- Sidebar Navigation Bar (always visible on right) -->
  @if ({isSmall: isSmallScreen()}; as screen) {
  <div
    class="sidebar-nav"
    [ngClass]="{
      'sidebar-nav--bottom': screen.isSmall,
      'sidebar-nav--right': !screen.isSmall
    }"
    [style.display]="display()"
  >
    <ul>
      <!-- Render sidebar items from service pages -->
      @for (page of sidebarService.pages(); track $index;) {
      <li
        class="nav-item"
        [ngClass]="{
          'sidebar-page_active': page.active,
          'last-item': sidebarService.pages().length > 1 && $last
        }"
        appTooltip
        [appTooltip]="page.title"
        position="left"
      >
        <button
          [disabled]="page.disabled"
          [style.width]="'100%'"
          [style.height]="'100%'"
          (click)="handlePageClick(page)"
        >
          <span>
            <!-- Use custom sidebar icon template if available, otherwise use default icon -->
            @if ('id' in page && getSidebarIconTemplate(page.id)) {
              <ng-container [ngTemplateOutlet]="getSidebarIconTemplate(page.id)"></ng-container>
            } @else {
              <i [class]="page.className"></i>
            }
          </span>
        </button>
      </li>
      }
    </ul>
  </div>
  }
</div>

<!-- Projected sidebar items for configuration -->
<ng-content></ng-content>
